import React from "react";
import useRightSidebar from "hooks/useRightSidebar";
import { Button } from "components/bootstrap";
const SidebarNavigationLink = ({ content, children }) => {
  const { openSidebar } = useRightSidebar();
  const handleClick = () => {
    openSidebar(content);
  };
  return /* @__PURE__ */ React.createElement(Button, { bsStyle: "link", onClick: handleClick }, children);
};
export default SidebarNavigationLink;
